import { MapSearchBlockContent } from '../../../../interfaces/map.interface';
import { SearchBlockContentStrategy } from './search-block-content.strategy';

export class ProjectSearchBlockContentStrategy extends SearchBlockContentStrategy {
  public constructor(mapSearchBlockContent: MapSearchBlockContent) {
    super(mapSearchBlockContent);
  }

  public emitSearchFormContent(): void {
    this.updateFieldsVisibility({
      roles: { hidden: true },
      charity_focuses: { hidden: true, disabled: true },
    });
  }
}
